import React from 'react';
import { Descriptions } from 'antd'
import Ts from './ts.png'
import styled from 'styled-components';
const Container = styled.div`
  width:100%;
  height:300px;
  background: #FFFFFF;
border-radius: 8px;
border: 1px solid #E0E4FF;
`;
const Top = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  border-radius: 8px 8px 0 0;
  background: #ECF2FF;
`;

const Image = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 8px;
  margin-left: 15px;
`;

const Text = styled.span`
font-family: MicrosoftYaHei;
font-size: 16px;
color: #333333;
`;

const Bottom = styled.div`
  display: flex;
  width: 100%;
  height: 260px;
`;

const RightSide = styled.div`
  flex: 0 0 30%;
  background: #FCFDFF;;
  border-left: 1px solid #E0E4FF;
`;

const Description = styled(Descriptions)`
  width: 95%;
  
  .ant-descriptions-item {
    margin-bottom: 16px;
  }
  :where(.css-dev-only-do-not-override-n0gjrg).ant-descriptions [class^="ant-descriptions"], :where(.css-dev-only-do-not-override-n0gjrg).ant-descriptions [class*=" ant-descriptions"] {
    margin-bottom: 10px;
}
  .ant-descriptions-item-label {
    font-family: MicrosoftYaHei;
    font-size: 20px;
    color: #333333;
    line-height: 22px;
    text-align: right;
    font-style: normal;
  }

  .ant-descriptions-item-content {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 18px;
    color: #2A2B2C;
    line-height: 22px;
    text-align: left;
    font-style: normal;
  }
`;

const LeftSide = styled.div`
  flex: 0 0 70%;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;


const Table = styled.div`
  height: 200px;
  padding: 25px;
  width: 80%;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const TableItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TableBt = styled.span`
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 20px;
  color: #0A8CEB;
  line-height: 22px;
  text-align: left;
  font-style: normal;
`;

const TableCs = styled.span`
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 20px;
  color: #2A2B2C;
  text-align: left;
  font-style: normal;
`;


export default (props) => {
  const {
    dipDiseGrpCode,
    homeSco,
    payStandards,
    rate,
    diseType,
    medfeeSumamt,
    diseListType,
    graRootDise,
    proLosAmount,
    hifpPay,
    predictedAmount,
    hifpBalance,
    hifpHosCost,
    hosDayBenchmark,
    dipDiseGrpName
  } = props.response;
  const days = props.form.getFieldsValue().act_ipt_days
  return (
    <Container>
      <Top>
        <Image src={Ts} alt="描述" />
        <Text>预测分组：<span style={{ color: '#0A8CEB' }}>{dipDiseGrpCode}</span>
          <span>{dipDiseGrpName === '' ? '未入组' : dipDiseGrpName}</span>（标准分值：<span style={{ color: '#CE0E0E' }}>{homeSco}</span>
          ，支付标准：<span style={{ color: '#CE0E0E' }}>{payStandards}</span> 元）</Text>
      </Top>
      <Bottom>
        <LeftSide>
          <Description size="middle" column={4}>
            <Descriptions.Item label="预测倍率" contentStyle={{ marginBottom: '12px' }}>
              {rate}
            </Descriptions.Item>

            <Descriptions.Item label="报销比例" contentStyle={{ marginBottom: '12px' }}>
              {isNaN(Math.round((hifpPay / medfeeSumamt) * 10000) / 100) || !hifpPay || !medfeeSumamt
                ? 0
                : (Math.round((hifpPay / medfeeSumamt) * 10000) / 100).toFixed(2)}%
            </Descriptions.Item>

            <Descriptions.Item label="盈亏比例" contentStyle={{ marginBottom: '12px' }}>
              {isNaN(Math.round((proLosAmount / hifpPay) * 10000) / 100) || !proLosAmount || !hifpPay
                ? <span style={{ color: 'green' }}>0</span>
                : (() => {
                  const result = Math.round((proLosAmount / hifpPay) * 10000) / 100;
                  const color = result < 0 ? 'red' : 'green';
                  return <span style={{ color }}>{result.toFixed(2)}%</span>;
                })()}
            </Descriptions.Item>

            <Descriptions.Item label="分组类别" contentStyle={{ marginBottom: '12px' }}>
              {diseType}
            </Descriptions.Item>

            <Descriptions.Item labelStyle={{ marginLeft: '20px' }} label="总费用" contentStyle={{ marginBottom: '12px' }}>
              {isNaN(medfeeSumamt) || medfeeSumamt === undefined || medfeeSumamt === null
                ? '0.00'
                : medfeeSumamt.toFixed(2)}
            </Descriptions.Item>

            <Descriptions.Item label="基本统筹" contentStyle={{ marginBottom: '12px' }}>
              {isNaN(hifpPay) || hifpPay === undefined || hifpPay === null
                ? '0.00'
                : hifpPay.toFixed(2)}
            </Descriptions.Item>

            <Descriptions.Item label="盈亏金额" contentStyle={{ marginBottom: '12px' }}>
              <span style={{ color: proLosAmount < 0 ? 'red' : 'green' }}>
                {isNaN(proLosAmount) || proLosAmount === undefined || proLosAmount === null
                  ? '0.00'
                  : proLosAmount.toFixed(2)}
              </span>
            </Descriptions.Item>

            <Descriptions.Item label="病组类型" contentStyle={{ marginBottom: '12px' }}>
              {diseListType}
            </Descriptions.Item>

            <Descriptions.Item label="应拨付额" contentStyle={{ marginBottom: '12px' }}>
              {isNaN(predictedAmount) || predictedAmount === undefined || predictedAmount === null
                ? '0.00'
                : predictedAmount.toFixed(2)}
            </Descriptions.Item>

            <Descriptions.Item label="拨付差额" contentStyle={{ marginBottom: '12px' }}>
              {(isNaN(hifpBalance) || hifpBalance === undefined || hifpBalance === null)
                ? '0.00'
                : (hifpBalance).toFixed(2)}
            </Descriptions.Item>

            <Descriptions.Item label="医院成本" contentStyle={{ marginBottom: '12px' }}>
            {isNaN(hifpHosCost) || hifpHosCost === undefined || hifpHosCost === null
                ? '0.00'
                : hifpHosCost.toFixed(2)}
            </Descriptions.Item>

            <Descriptions.Item label="基层病种" contentStyle={{ marginBottom: '12px' }}>
              {graRootDise}
            </Descriptions.Item>
          </Description>

        </LeftSide>
        <RightSide>
          <Table>

            <TableItem>
              <div></div>
              <div><TableBt style={{ marginLeft: '30px' }}>实际值</TableBt></div>
              <div><TableBt style={{ marginLeft: '-50px' }}>标杆</TableBt></div>
              <div><TableBt style={{ marginLeft: '-70px' }}>偏差</TableBt></div>
            </TableItem>
            <TableItem>
              <div><TableBt>住院天数</TableBt></div>
              <div><TableCs style={{ marginLeft: '-45px' }}>{days || 0}</TableCs></div>
              <div><TableCs style={{ marginLeft: '-45px' }}>{hosDayBenchmark || 0}</TableCs></div>
              <div><TableCs style={{ marginLeft: '-45px' }}>{(hosDayBenchmark || 0) - (days || 0)}</TableCs></div>
            </TableItem>
            {(props.requestParam && props.requestParam.length !== 0) ? (
              // 如果 requestParam 不为空，渲染每一项
              props.requestParam.map((res, index) => (
                <TableItem key={index}>
                  <div><TableBt>{res.medChrgitmName || '未知'}</TableBt></div>
                  <div><TableCs style={{ marginLeft: '-45px' }}>{res.ratio || 0}</TableCs></div>
                  <div><TableCs style={{ marginLeft: '-45px' }}>{res.ratioMark || 0}</TableCs></div>
                  <div><TableCs style={{ marginLeft: '-45px' }}>
                    {(res.ratioMark || 0) - (res.ratio || 0)}
                  </TableCs></div>
                </TableItem>
              ))
            ) : (
              // 如果 requestParam 为空，显示默认的占比信息
              <>
                <TableItem>
                  <div><TableBt>药材占比</TableBt></div>
                  <div><TableCs style={{ marginLeft: '-45px' }}></TableCs></div>
                  <div><TableCs style={{ marginLeft: '-45px' }}></TableCs></div>
                  <div><TableCs style={{ marginLeft: '-45px' }}></TableCs></div>
                </TableItem>
                <TableItem>
                  <div><TableBt>耗材占比</TableBt></div>
                  <div><TableCs style={{ marginLeft: '-45px' }}></TableCs></div>
                  <div><TableCs style={{ marginLeft: '-45px' }}></TableCs></div>
                  <div><TableCs style={{ marginLeft: '-45px' }}></TableCs></div>
                </TableItem>
              </>
            )}

          </Table>
        </RightSide>
      </Bottom>
    </Container>

  );
};

